import { type FC } from 'react';
import { useSearchParams } from 'react-router-dom';

import FilterIcon from '@/assets/icons/filter.svg?react';
import SearchInput from '@/components/shared/search-input';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import useIncidentSearch from '@/hooks/use-incident-search';
import { SEARCH_PARAM_INCIDENTS, SEARCH_PARAM_SHOW } from '@/utils/constants/queries';

interface IncidentListStickyContentProps {
  filterCount: number;
  onShowFilter: () => void;
}

const IncidentListStickyContent: FC<IncidentListStickyContentProps> = ({
  filterCount,
  onShowFilter,
}) => {
  const [searchParams] = useSearchParams();
  const { searchKey, setSearchKey } = useIncidentSearch();
  const showFilter = searchParams.get(SEARCH_PARAM_SHOW) === SEARCH_PARAM_INCIDENTS;

  return (
    <div className="h-9 flex items-center gap-1 bg-white opacity-100">
      <div className="grow min-w-0 h-full">
        <SearchInput onChange={setSearchKey} initialValue={searchKey} />
      </div>
      {showFilter && (
        <div className="relative">
          <Button
            size="icon"
            className="w-9 h-9 px-1 py-[3px] items-center justify-center rounded-md border-none shadow-none bg-transparent hover:bg-accent cursor-pointer"
            onClick={onShowFilter}
            role="button"
            aria-label="incident-filter"
          >
            <FilterIcon className="size-6" />
          </Button>
          {filterCount > 0 && (
            <Badge className="absolute top-0 right-0 w-4 h-4 rounded-full text-[9px] flex justify-center items-center pointer-events-none">
              {filterCount}
            </Badge>
          )}
        </div>
      )}
    </div>
  );
};

export default IncidentListStickyContent;
